import React, { useState, useEffect } from "react";
import Autosuggest from "react-autosuggest";
import styles from "./flight.module.css";
import "./TrainHomepage.css";
import { useNavigate } from "react-router-dom";
import data from "./stations.json";



export const TrainSearch = () => {
  const [fromSuggestions, setFromSuggestions] = useState([]);
  const [toSuggestions, setToSuggestions] = useState([]);

  const [type, setType] = useState("ONE_WAY");
  const [departureDate, setDepartureDate] = useState("");
  const [airportsData, setAirportsData] = useState([]);
  const navigate = useNavigate();
  const [fromValue, setFromValue] = useState("");
  const [toValue, setToValue] = useState("");


  // useEffect(() => {
  //   airports()
  //     .then((res) => {
  //       setAirportsData(res.data);
  //       console.log(res.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);
useEffect(() => {
  setAirportsData(data.features);
}, []);
  const swapValuehandler = () => {
    let temp = fromValue;
    setFromValue(toValue);
    setToValue(temp);
  };

const fetchSuggestions = (value) => {
  const inputValue = value.trim().toLowerCase();
  console.log("Input Value:", inputValue);
  console.log("Airports Data:", airportsData);

  if (!airportsData) {
    return []; // Return an empty array if airportsData is null
  }

  const filteredSuggestions = airportsData.filter(
    (airport) =>
      airport.properties.name?.toLowerCase().includes(inputValue) || // Add null check with optional chaining (?.)
      airport.properties.code?.toLowerCase().includes(inputValue) || // Add null check with optional chaining (?.)
      airport.properties.address?.toLowerCase().includes(inputValue) // Add null check with optional chaining (?.)
  );
  return filteredSuggestions.slice(0, 5); // Limit the suggestions to 5
};

  const getSuggestionValue = (suggestion) => suggestion.properties.code;

const renderSuggestion = (suggestion) => (
 
  <div className="suggestion-item">
    <div className="suggestion-content">
      <span className="suggestion-name">{suggestion.properties.name}</span>
      <span className="suggestion-details">
        {suggestion.properties.address}-{suggestion.properties.code}
      </span>
    </div>
    <hr className="suggestion-divider" />
   
  </div>
  
);

  const onFromSuggestionsFetchRequested = ({ value }) => {
    setFromSuggestions(fetchSuggestions(value));
  };

  const onToSuggestionsFetchRequested = ({ value }) => {
    setToSuggestions(fetchSuggestions(value));
  };

  const onFromSuggestionsClearRequested = () => {
    setFromSuggestions([]);
  };

  const onToSuggestionsClearRequested = () => {
    setToSuggestions([]);
  };

  const onFromChange = (event, { newValue }) => {
    setFromValue(newValue);
  };

  const onToChange = (event, { newValue }) => {
    setToValue(newValue);
  };

  const fromInputProps = {
    placeholder: "From",
    value: fromValue,
    onChange: onFromChange,
  };

  const toInputProps = {
    placeholder: "To",
    value: toValue,
    onChange: onToChange,
  };

 const renderSuggestionsContainer = ({ containerProps, children }) => (
   <div
     {...containerProps}
     className="custom-suggestions-container"
     style={{ width: "100%"}}
   >
     {children}
   </div>
 );



 const handleSubmit = () => {
  if (fromValue && toValue && departureDate) {
    const data = {
      from: fromValue,
      to: toValue,
      departure_date: departureDate,
    };
    navigate("/TrainList", { state: data });
  }
};

  return (
    <>
      <div className="homeInputBx" id="flightinputBx">
        {/* <div>
          <div className="homeInputs">
            <input
              name="type"
              type="radio"
              id="inputs"
              value="ONE_WAY"
              onChange={(e) => setType(e.target.value)}
            />
            <label htmlFor="inputs">ONE WAY</label>
          </div>
          <div className="homeInputs">
            <input
              name="type"
              type="radio"
              id="inputs2"
              value="ROUND_TRIP"
              onChange={(e) => setType(e.target.value)}
            />
            <label htmlFor="inputs2">ROUND TRIP</label>
          </div>
        </div> */}
        <p></p>
      </div>

      <div className="homeMainSearchInput" id="homeMainSearchInputc1">
        <div className="MainSearchinputBx">
          <span>FROM</span>
          <Autosuggest
            suggestions={fromSuggestions}
            onSuggestionsFetchRequested={onFromSuggestionsFetchRequested}
            onSuggestionsClearRequested={onFromSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            renderSuggestionsContainer={renderSuggestionsContainer}
            inputProps={fromInputProps}
            id="from"
          />
          <button onClick={swapValuehandler}>
            <i className="fa fa-exchange"></i>
          </button>
        </div>

        <div className="MainSearchinputBx">
          <span>TO</span>
          <Autosuggest
            suggestions={toSuggestions}
            onSuggestionsFetchRequested={onToSuggestionsFetchRequested}
            onSuggestionsClearRequested={onToSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            renderSuggestionsContainer={renderSuggestionsContainer}
            inputProps={toInputProps}
            id="fromTo"
          />
        </div>
        <div className="MainSearchinputBx">
          <span>DEPARTURE</span>
          <input
            type="date"
            value={departureDate}
            onChange={(e) => setDepartureDate(e.target.value)}
          />
        </div>
      
      </div>
      <div className="Homeoptions" id="Homeoptions">
        <h3>Select Categoiers:</h3>
        <div className="optionsInputBx">
          <input type="radio" name="fares" />
          <p>General</p>
        </div>
        <div className="optionsInputBx">
          <input type="radio" name="fares" />
          <p> Sleeper</p>
        </div>

        <div className="optionsInputBx">
          <input type="radio" name="fares" />
          <p>AC</p>
        </div>
      </div>

      <div className="homeSearchButtonBx">
      <button
          onClick={() => handleSubmit()}
          disabled={!fromValue || !toValue || !departureDate}
          className={(!fromValue || !toValue || !departureDate) ? 'disabled-button' : ''}
        >Search</button>
      </div>
    </>
  );
};

export default TrainSearch;
